import { SelfServeNode, SelfServeNodes } from "../types";

/**
 * Filters out nodes that are not in the tree or that do not have a label
 */
export const getNodesThatCanBeRendered = (
  tree: SelfServeNodes,
  children: string[]
): SelfServeNode[] => {
  return children
    .map((childId) => tree[childId])
    .filter((node) => node && node.label)
    .map((node) => node as SelfServeNode);
};
